import { useLocation } from '@lingoda/router';
import { useIsFFreeTrial } from '@lingoda/f-free-trial';
import { getStorageValue } from '@lingoda/utils';
import { STORAGE_KEY_INITIAL_IS_IN_TRIAL } from '../../constants';
import { ProgressBar } from './ProgressBar';
import { getPostCheckoutSteps } from './utils';

export const PostCheckoutProgressBar = () => {
    const { pathname } = useLocation();
    const isFFreeTrial = useIsFFreeTrial();
    const initialIsInTrial = !!getStorageValue(STORAGE_KEY_INITIAL_IS_IN_TRIAL);
    const steps = getPostCheckoutSteps(isFFreeTrial, initialIsInTrial);
    const activeStep = steps.findIndex((step) => pathname.startsWith(step.toString())) + 1;

    return <ProgressBar activeStep={activeStep} totalSteps={steps.length} />;
};
